<template lang="html">
  <div>
    <v-row class="justify-center mt-4 mb-4">
      <v-col cols="auto" class="d-flex shrink text-left">
        <img src="concorde-logo-new-white.png" alt="" style="max-height: 80px;" />
      </v-col>
    </v-row>

    <v-row class="justify-center mb-5">
      <v-col cols="12" sm="8" md="6" lg="5">
        <v-card>
          <v-card-title>
            <v-row class="justify-center">
              <v-col cols="12" class="text-center">
                <h2>Create a new account</h2>
                <div class="subtitle-2">Create a password for your new account</div>
                <v-divider class="mt-3"></v-divider>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="justify-center" dense>
              <v-col cols="12" class="text-center">
                <v-text-field
                  v-model.trim="email"
                  outlined
                  name="email"
                  label="Email Address"
                  hint="Enter your email address."
                  clearable
                  @click:clear="$router.push('/log-in')"
                />
              </v-col>
              <v-col cols="12" class="text-center mb-2">
                <v-text-field
                  ref="password"
                  v-model.trim="password"
                  name="password"
                  outlined
                  label="Create a password for your account"
                  type="password"
                  hint="Your new password should be at least 6 charaters long."
                  persistent-hint
                  loading
                  clearable
                  @keyup.enter="signup()"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      :value="passStrengthVal"
                      :color="passStrengthColor"
                      absolute
                      height="3"
                    ></v-progress-linear>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-alert v-model="emailDoesNotExist" type="error">
                  The email address you entered was not found in our system. Please check that the email
                  address you entered is the same one you provided when registering. If you want to use a
                  different email address, please get in touch with us.
                </v-alert>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn :loading="loading" block large color="primary" @click.stop="signup()">
                  Sign Up
                </v-btn>
              </v-col>
              <v-col cols="12" class="text-center">
                <p class="mt-5">
                  <nuxt-link class="mt-5" to="/log-in">
                    Already have an account?
                  </nuxt-link>
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    email: null,
    password: null,
    emailDoesNotExist: false
  }),
  computed: {
    passStrengthVal() {
      const { password } = this
      return (100 / 6) * ((password && password.length) || 0)
    },
    passStrengthColor() {
      const { passStrengthVal } = this
      return passStrengthVal > 80 ? 'green' : passStrengthVal > 40 ? 'orange' : 'red'
    }
  },
  watch: {
    email() {
      this.emailDoesNotExist = false
    }
  },
  mounted() {
    const { q, email } = this.$route.query
    if (q) {
      this.email = q.email || null
    }
    if (email) {
      this.email = email
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    }
  },
  methods: {
    async signup() {
      try {
        let { email, password } = this
        if (!email) {
          return this.$snack('Email should not be blank!')
        }
        if (!password) {
          return this.$snack('Password should not be blank!')
        }
        this.loading = true
        email.toLowerCase()
        await this.$user.signup(email, password)
        this.$router.push('/set-up-account')
        // set timeout here as the redirect is handled by auth watcher and can be delayed.
        setTimeout(() => {
          this.loading = false
        }, 1000)
      } catch (e) {
        this.loading = false
        if (e.code === 'error/email-does-not-exist') {
          this.emailDoesNotExist = true
        } else {
          this.$handleError(e)
        }
      }
    }
  }
}
</script>

<style lang="css"></style>
